import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
export const SUPPORTED_LOCALES = ['fr', 'en'];
export const DEFAULT_LOCALE = 'fr';
export function isSupportedLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
/**
 * Picks a starting locale from the browser, falling back to French.
 *
 * Only ever a default: once a user is signed in, their stored preference wins,
 * because it is what emails are sent in too and the two must not disagree.
 */
export function detectLocale(languages = globalThis.navigator?.languages ?? []) {
    for (const tag of languages) {
        const base = tag.split('-')[0]?.toLowerCase() ?? '';
        if (isSupportedLocale(base))
            return base;
    }
    return DEFAULT_LOCALE;
}
/**
 * The active locale, narrowed to one the formatters accept.
 *
 * `useI18n()` types `locale` as a plain `string`, so every call to
 * `formatDate` and friends would otherwise narrow it again by hand - and one
 * call site getting the fallback wrong shows dates in the wrong language with
 * nothing anywhere to explain it.
 */
export function useLocale() {
    const { locale } = useI18n();
    return computed(() => (isSupportedLocale(locale.value) ? locale.value : DEFAULT_LOCALE));
}
//# sourceMappingURL=locale.js.map